// extracted by mini-css-extract-plugin
module.exports = {"card":"GoalCard_card__ya1KY","body":"GoalCard_body__9p1px","title":"GoalCard_title__Of2Br","chevron":"GoalCard_chevron__GlPfj","members":"GoalCard_members__xvZ5h"};